import { StaticImage } from 'gatsby-plugin-image';
import { useIntl } from 'gatsby-plugin-react-intl';
import * as React from 'react';
import { useSiteMetadata } from '../../../../hooks/useSiteMetadata';
import * as styles from './eu-program-2.module.scss';

export const EuProgram2 = () => {
  const intl = useIntl();
  const { siteMainLang } = useSiteMetadata();

  if (intl.locale !== siteMainLang) {
    return null;
  }
  return (
    <div className={styles.euProgram}>
      <StaticImage
        src="../../../../images/about-us/Plakat-Grand.png"
        placeholder="tracedSVG"
        loading="lazy"
        width={800}
        quality={95}
        formats={['auto', 'webp', 'avif']}
        alt={intl.formatMessage({ id: 'about_us.eu_program_2.image.alt' })}
      />
    </div>
  );
};
